import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardPage from '../pages/DashboardPage';

/**
 * На корне (/) и /dashboard: родитель без роли ученика → кабинет родителя.
 * Преподаватель остаётся на главной (плашки разделов).
 */
export default function DashboardOrRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.is_parent && !user.is_student && !user.is_teacher) {
    return <Navigate to="/parent" replace />;
  }

  return <DashboardPage />;
}
